import { Button } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import React from "react";

export const SubmitOnlinePay = ({ data }) => {
  if (!data) return null;

  const {
    CONCEPTOPLINEA,
    LINEA_CAPTURA,
    IMPORTE,
    FECHAPLINEA,
    TOKEN,
    URLRETORNO,
  } = data;

  return (
    <form
      action={process.env.REACT_APP_URLPAGO}
      method="post"
      style={{ width: "100%" }}
    >
      <input type="hidden" name="concepto" value={CONCEPTOPLINEA || ""} />
      <input type="hidden" name="lcaptura" value={LINEA_CAPTURA || ""} />
      <input type="hidden" name="monto" value={IMPORTE || ""} />
      <input type="hidden" name="fecha_vencimiento" value={FECHAPLINEA || ""} />
      <input type="hidden" name="tkn" value={TOKEN || ""} />
      <input type="hidden" name="urlDiversos" value={URLRETORNO || ""} />
      <input type="hidden" name="urlRetorno" value={URLRETORNO || ""} />
      <input type="hidden" name="email" value="" />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        startIcon={<LaunchIcon />}
        sx={{
          backgroundColor: "var(--main-color-vino)",
          padding: "12px",
          fontWeight: "700",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(128, 0, 32, 0.2)",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: "var(--main-color-vino)",
            boxShadow: "0 6px 16px rgba(128, 0, 32, 0.35)",
            transform: "translateY(-3px)",
          },
          "&:active": {
            transform: "translateY(1px)",
          },
          "&.Mui-disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        Proceder al Portal de Pago
      </Button>
    </form>
  );
};
